module.exports = __webpack_public_path__ + "img/578.cc00b153.jpg";